/* hs-eslint ignored failing-rules */
/* eslint-disable react/prop-types */

'use es6';

import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["color", "highlights", "selected", "size", "title"];
import PropTypes from 'prop-types';
import { memo } from 'react';
import styled from 'styled-components';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const borderRatio = 0.09;
const getWrapperStyle = ({
  color,
  highlights,
  size
}) => {
  const bSize = highlights ? Math.ceil(borderRatio * size) : 0;
  return `
    border-color: ${color};
    border-width: ${bSize}px;
    padding: ${bSize}px;
  `;
};
const Wrapper = styled.span.withConfig({
  displayName: "CsatButton__Wrapper",
  componentId: "t1nhzr-0"
})(["cursor:pointer;display:inline-block;border-radius:50%;border-style:solid;", " transition:border-color linear 0.2s;&:not(:hover):not(.selected){border-color:transparent;}"], getWrapperStyle);
const StyledSvg = styled.svg.withConfig({
  displayName: "CsatButton__StyledSvg",
  componentId: "t1nhzr-1"
})(["display:block;"]);
const CsatButton = /*#__PURE__*/memo(props => {
  const {
      color,
      highlights,
      selected,
      size,
      title
    } = props,
    rest = _objectWithoutPropertiesLoose(props, _excluded);
  const svgSize = highlights ? size - size * borderRatio * 2 : size;
  return /*#__PURE__*/_jsx(Wrapper, Object.assign({
    className: selected ? "selected" : "",
    color: color,
    highlights: highlights,
    size: size
  }, rest, {
    role: "button",
    children: /*#__PURE__*/_jsxs(StyledSvg, {
      xmlns: "http://www.w3.org/2000/svg",
      width: svgSize,
      height: svgSize,
      viewBox: "0 0 54 54",
      children: [/*#__PURE__*/_jsx("title", {
        children: title
      }), /*#__PURE__*/_jsx("g", {
        id: "Connecting-Feedback-CSAT-survey-to-chat",
        stroke: "none",
        strokeWidth: "1",
        fill: "none",
        fillRule: "evenodd",
        children: props.children
      })]
    })
  }));
});
CsatButton.propTypes = {
  color: PropTypes.string.isRequired,
  highlights: PropTypes.bool,
  selected: PropTypes.bool,
  size: PropTypes.number.isRequired,
  title: PropTypes.node
};

/* eslint-disable-next-line hubspot-dev/no-default-props-assignment */
CsatButton.defaultProps = {
  highlights: true,
  selected: false
};
export default CsatButton;